"use client";

import Image from "next/image";

import { ARCADE_STYLES } from "@/constants/arcade-styles";

const Mememaker = () => {
  return (
    <div className="3xl:max-w-7xl mx-auto w-full max-w-5xl min-h-[calc(100dvh-128px)] md:min-h-screen">
      <div className="relative mx-auto md:mt-16 flex h-[calc(100dvh-128px-8px)] md:h-auto w-full items-stretch p-4 font-inter">
        {/* Cabinet bezel — solid TV_FRAME chrome (cobalt rim, dark
            moondust gradient). Same vocabulary as the lobby tetris
            cabinet + music player. */}
        <div
          className="relative mt-4 mb-0 w-full rounded-md p-4 h-[calc(100%-8px)]"
          style={ARCADE_STYLES.TV_FRAME}
        >
          {/* Floating MEME MAKER sign — cobalt whisper drop-shadow,
              kansei-flicker-b for the rare opacity dip. */}
          <div className="kansei-flicker-b absolute -top-8 left-0 md:-top-8 md:left-8 z-50">
            <div className="relative h-16 w-48 md:h-20 md:w-52">
              <Image
                src="/lobby/mememaker.svg"
                alt="MEME MAKER"
                fill
                className="object-contain"
                style={{
                  filter:
                    "grayscale(0.7) brightness(0.78) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.6)) drop-shadow(0 0 2px rgba(94, 123, 250, 0.4))",
                }}
              />
            </div>
          </div>

          {/* Recessed screen — solid TICKER_CONTAINER chrome wraps the
              iframe. The iframe is inset by 3px so the cobalt rim sits
              visible at the edge — without inset, an absolute inset-0
              iframe would cover the rim and the screen border would
              read transparent. */}
          <div
            className="relative w-full h-full md:h-auto md:aspect-[4/3] overflow-hidden rounded"
            style={ARCADE_STYLES.TICKER_CONTAINER}
          >
            <iframe
              src="https://www.beraflip.com/henlo"
              className="absolute inset-[3px] size-[calc(100%-6px)] rounded-[2px]"
              title="Beraflip Meme Maker"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mememaker;
